import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { fetcher } from '../services/api';

export default function ComparePage() {
  const { id1, id2 } = useParams();
  const { data, isLoading } = useSWR(`compare/${id1}/${id2}`, fetcher);

  if (isLoading) {
    return <div className="max-w-7xl mx-auto px-4 py-12">Cargando comparación...</div>;
  }

  if (!data?.data) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-12 text-center">
        <h1 className="text-2xl font-bold text-gray-900">Error al cargar</h1>
      </div>
    );
  }

  const { politician1, politician2, comparison } = data.data;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">Comparación</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        {/* Politician 1 */}
        <div className="card text-center">
          <img src={politician1.photo_url} alt={politician1.full_name} className="w-32 h-32 rounded-full mx-auto mb-4 bg-gray-200" />
          <h2 className="text-xl font-bold text-gray-900">{politician1.full_name}</h2>
          <p className="text-gray-600">{politician1.position_title}</p>
          <p className="text-sm text-gray-500">{politician1.party_name}</p>
        </div>

        {/* Politician 2 */}
        <div className="card text-center">
          <img src={politician2.photo_url} alt={politician2.full_name} className="w-32 h-32 rounded-full mx-auto mb-4 bg-gray-200" />
          <h2 className="text-xl font-bold text-gray-900">{politician2.full_name}</h2>
          <p className="text-gray-600">{politician2.position_title}</p>
          <p className="text-sm text-gray-500">{politician2.party_name}</p>
        </div>
      </div>

      {/* Comparison Metrics */}
      <div className="card">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Métricas comparativas</h2>

        {/* Attendance */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-700 mb-3">Asistencia</h3>
          <div className="flex items-center space-x-4">
            <div className={`flex-1 font-bold ${comparison.attendance.winner === politician1.id ? 'text-green-600' : 'text-gray-600'}`}>
              {comparison.attendance.p1}%
            </div>
            <div className="flex-1 bg-gray-200 rounded-full h-4">
              <div
                className={`h-4 rounded-full ${comparison.attendance.winner === politician1.id ? 'bg-green-500' : 'bg-gray-400'}`}
                style={{ width: `${comparison.attendance.p1}%` }}
              />
            </div>
            <div className="w-20 text-center text-sm text-gray-500">vs</div>
            <div className="flex-1 bg-gray-200 rounded-full h-4">
              <div
                className={`h-4 rounded-full ${comparison.attendance.winner === politician2.id ? 'bg-green-500' : 'bg-gray-400'}`}
                style={{ width: `${comparison.attendance.p2}%` }}
              />
            </div>
            <div className={`flex-1 font-bold ${comparison.attendance.winner === politician2.id ? 'text-green-600' : 'text-gray-600'}`}>
              {comparison.attendance.p2}%
            </div>
          </div>
        </div>

        {/* Initiatives */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-700 mb-3">Iniciativas</h3>
          <div className="flex items-center space-x-4">
            <div className={`flex-1 font-bold ${comparison.initiatives.winner === politician1.id ? 'text-blue-600' : 'text-gray-600'}`}>
              {comparison.initiatives.p1}
            </div>
            <div className="text-sm text-gray-500">iniciativas</div>
            <div className="w-20 text-center text-sm text-gray-500">vs</div>
            <div className="text-sm text-gray-500">iniciativas</div>
            <div className={`flex-1 font-bold ${comparison.initiatives.winner === politician2.id ? 'text-blue-600' : 'text-gray-600'}`}>
              {comparison.initiatives.p2}
            </div>
          </div>
        </div>

        {/* Overall */}
        <div>
          <h3 className="font-semibold text-gray-700 mb-3">Puntuación general</h3>
          <div className="flex items-center justify-between">
            <div className={`text-3xl font-bold ${comparison.overall.winner === politician1.id ? 'text-green-600' : 'text-gray-600'}`}>
              {comparison.overall.p1}
            </div>
            <div className="text-gray-400">vs</div>
            <div className={`text-3xl font-bold ${comparison.overall.winner === politician2.id ? 'text-green-600' : 'text-gray-600'}`}>
              {comparison.overall.p2}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
